// @flow
/**
 * @class Projection
 * @MapGISExtension
 * @classdesc 投影对象，用于处理CRS中投影和反投影操作
 * @category Base
 * @return {Projection} 投影对象
 */
class Projection {
    /**
     * @description: 正投影(子类需要实现)
     * @param {Array<Number>|{lng:Number,lat:Number}} lnglat 经纬度对象或数组
     * @return {Array<Number>}
     */
    project(
        lnglat: Array<Number> | { lng: Number, lat: Number }
    ): Array<Number> {
        let lng, lat;
        if (Array.isArray(lnglat)) {
            lng = lnglat[0];
            lat = lnglat[1];
        } else {
            lng = lnglat.lng;
            lat = lnglat.lat;
        }
        return [lng, lat];
    }

    /**
     * @description: 反投影(子类需要实现)
     * @param {Array<Number>|{x:Number,y:Number}} point 点
     * @return {Array<Number>}
     */
    unproject(point: Array<Number> | { x: Number, y: Number }): Array<Number> {
        let x, y;
        if (Array.isArray(point)) {
            x = point[0];
            y = point[1];
        } else {
            x = point.x;
            y = point.y;
        }
        return [x, y];
    }
}
export default Projection;
